import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, Validators } from '@angular/forms';
import { DowngradeEntitlement } from '@app/shared/+state/billing';
import { LoadingState } from '@app/shared/interfaces';
import { UserManagementService } from '@app/shared/services/user-management/user-management.service';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  standalone: false,
  selector: 'sbnb-downgrade-delete-users',
  templateUrl: './downgrade-delete-users.component.html',
  styleUrls: ['./downgrade-delete-users.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DowngradeDeleteUsersComponent implements OnInit {
  @Input() maxSecondaryUsersEntitlement: DowngradeEntitlement;
  @Output() cancel = new EventEmitter<void>();
  @Output() previous = new EventEmitter<void>();
  @Output() submissionSuccess = new EventEmitter<void>();

  private submissionState$ = new BehaviorSubject<LoadingState>(LoadingState.NotSent);
  public unsubmitted$ = this.submissionState$.pipe(map((state) => state === LoadingState.NotSent));
  public submitting$ = this.submissionState$.pipe(map((state) => state === LoadingState.Pending));
  public success$ = this.submissionState$.pipe(map((state) => state === LoadingState.Success));
  public error$ = this.submissionState$.pipe(map((state) => state === LoadingState.Error));

  public deleteUsersForm = this.fb.group({
    users: this.fb.control([], this.tooFewValidator.bind(this)),
    confirm: this.fb.control(false, [Validators.requiredTrue]),
  });

  constructor(
    private readonly fb: UntypedFormBuilder,
    private userMgtService: UserManagementService
  ) { }

  ngOnInit(): void { }

  public deleteUsers(): void {
    this.submissionState$.next(LoadingState.Pending);
    this.userMgtService.deleteUsers(this.deleteUsersForm.get('users').value).subscribe((res) => {
      if ((res as any)?.error) {
        this.submissionState$.next(LoadingState.Error);
        return;
      }
      this.submissionState$.next(LoadingState.Success);
      this.submissionSuccess.emit();
    });
  }

  private tooFewValidator(control: UntypedFormArray) {
    if (control?.value?.length < this.maxSecondaryUsersEntitlement?.disable) {
      return { tooFew: true };
    }
    return null;
  }
}
